import { IPageTabNavLink } from "../interfaces-and-types";

export const subemailLink: IPageTabNavLink[] = [
    {
        name: 'Subscription and emails',
        route: '',
    },
]